/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Locked_Success_ToastInputs */

const en_explorer_info_locked_success_toast = /** @type {(inputs: Explorer_Info_Locked_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Record locked successfully`)
};

const fr_explorer_info_locked_success_toast = /** @type {(inputs: Explorer_Info_Locked_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrement verrouille avec succes`)
};

const de_explorer_info_locked_success_toast = /** @type {(inputs: Explorer_Info_Locked_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datensatz erfolgreich gesperrt`)
};

const it_explorer_info_locked_success_toast = /** @type {(inputs: Explorer_Info_Locked_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Record bloccato con successo`)
};

const ru_explorer_info_locked_success_toast = /** @type {(inputs: Explorer_Info_Locked_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запись успешно заблокирована.`)
};

const es_explorer_info_locked_success_toast = /** @type {(inputs: Explorer_Info_Locked_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro bloqueado exitosamente`)
};

const zh_cn2_explorer_info_locked_success_toast = /** @type {(inputs: Explorer_Info_Locked_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`记录已成功锁定`)
};

const ja_explorer_info_locked_success_toast = /** @type {(inputs: Explorer_Info_Locked_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レコードが正常にロックされました`)
};

const hi_explorer_info_locked_success_toast = /** @type {(inputs: Explorer_Info_Locked_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिकॉर्ड सफलतापूर्वक लॉक हो गया`)
};

const pt_pt2_explorer_info_locked_success_toast = /** @type {(inputs: Explorer_Info_Locked_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro bloqueado com sucesso`)
};

/**
* | output |
* | --- |
* | "Record locked successfully" |
*
* @param {Explorer_Info_Locked_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_locked_success_toast = /** @type {((inputs?: Explorer_Info_Locked_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Locked_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_locked_success_toast(inputs)
	if (locale === "de") return de_explorer_info_locked_success_toast(inputs)
	if (locale === "it") return it_explorer_info_locked_success_toast(inputs)
	if (locale === "ru") return ru_explorer_info_locked_success_toast(inputs)
	if (locale === "es") return es_explorer_info_locked_success_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_locked_success_toast(inputs)
	if (locale === "ja") return ja_explorer_info_locked_success_toast(inputs)
	if (locale === "hi") return hi_explorer_info_locked_success_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_locked_success_toast(inputs)
	return en_explorer_info_locked_success_toast(inputs)
});